import React from 'react'
import Layouts from '../layouts/Layouts'
import { Link, useLocation, useParams } from 'react-router-dom'
import { BusinessCenter, WorkOff } from '@mui/icons-material';
import { Toaster } from 'react-hot-toast';

const Operasional = ({ children }) => {
    const { username } = useParams();
    const location = useLocation();
    const path = location.pathname;
    const split = path.split('/');

    return (
        <Layouts>
            <Toaster position="top-center" />
            <div>
                <h1>BIAYA</h1>
            </div>

            <div className="mt-3">
                <div className="card">
                    <div className="card-body">
                        <div className="sub-menu">
                            <ul>
                                <li>
                                    <Link to={`/${username}/operasional/bisnis/data`} className={` sub-menu-item ${split[3] === 'bisnis'? 'active' : ''} `}>
                                        <div className="me-2">
                                            <BusinessCenter />
                                        </div>
                                        <span>Biaya Bisnis</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to={`/${username}/operasional/non-bisnis/data`} className={` sub-menu-item ${split[3] === 'non-bisnis'? 'active' : ''} `} >
                                        <div className="me-2">
                                            <WorkOff />
                                        </div>
                                        <span>Biaya Non Bisnis</span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            { children }
        </Layouts>
    )
}

export default Operasional
